export const NAME_COMMA_ERROR = "Names cannot contain commas"

/** Strip commas when pre-populating name fields from API/customer/order data. */
export function stripCommasFromName(value) {
    return String(value ?? "").replace(/,/g, "")
}

export function nameHasComma(value) {
    return String(value ?? "").includes(",")
}

/**
 * Top-to-bottom order for submit focus (contact → shipping when ship → billing).
 * @param {{
 *   contact: { firstName?: string, lastName?: string },
 *   delivery: { method?: string },
 *   shipping: { firstName?: string, lastName?: string },
 *   billing: { firstName?: string, lastName?: string },
 * }} model
 * @returns {{ domId: string, sectionIndex: number } | null}
 */
export function findFirstOrderFormNameFieldWithComma(model) {
    /** @type {{ domId: string, sectionIndex: number, value?: string }[]} */
    const fields = [
        { sectionIndex: 0, domId: "new-order-contact-first-name", value: model.contact?.firstName },
        { sectionIndex: 0, domId: "new-order-contact-last-name", value: model.contact?.lastName },
    ]

    if (model.delivery?.method === "ship") {
        fields.push(
            { sectionIndex: 2, domId: "shipping-first-name", value: model.shipping?.firstName },
            { sectionIndex: 2, domId: "shipping-last-name", value: model.shipping?.lastName },
        )
    }

    fields.push(
        { sectionIndex: 3, domId: "billing-first-name", value: model.billing?.firstName },
        { sectionIndex: 3, domId: "billing-last-name", value: model.billing?.lastName },
    )

    for (const field of fields) {
        if (nameHasComma(field.value)) {
            return { domId: field.domId, sectionIndex: field.sectionIndex }
        }
    }
    return null
}
